export const TYPES = {
  LOADING: "operator/LOADING",
  OPERATOR_LIST_SUCCESS: "operator/OPERATOR_LIST_SUCCESS",
  GET_PERMISSIONS_SUCCESS: "operator/GET_PERMISSIONS_SUCCESS",
  GET_OPERATOR_SUCCESS: "operator/GET_OPERATOR_SUCCESS",
  SELECT_OPERATOR_SUCCESS: "operator/SELECT_OPERATOR_SUCCESS",
  SELECT_OPERATOR_ADD: "operator/SELECT_OPERATOR_ADD",
  OPERATOR_ADD_SUCCESS: "operator/OPERATOR_ADD_SUCCESS",
};
